import { Component, QueryList, ViewChildren } from '@angular/core';
import { GwAuthSettingsComponent } from '../..';
import { MessageService } from 'base';


@Component({
	selector: 'auth-settings',
	templateUrl: './auth-settings.component.html',
	styleUrls: ['./auth-settings.component.scss']
})
export class AuthSettingsComponent {

	@ViewChildren(GwAuthSettingsComponent)
	public gwAuthSettings: QueryList<GwAuthSettingsComponent>;

	constructor(private messageService: MessageService) {
		return;
	}

	public onOauthSave(): void {
		this.gwAuthSettings.first.onOauthSave();
	}

	public onAdminLoginFailed(): void {
		this.messageService.displayErrorMessage("Login failed");
		this.gwAuthSettings.first.onAdminLoginFailed();
	}

}
